module.exports = __webpack_public_path__ + "img/scene-icon-6.628f7ee7.png";